import { useQuery } from '@tanstack/react-query';

import API from 'services/api';
import FormSubmitError from 'errors/FormSubmitError';
import SettingsDto from 'types/api/SettingsDto';
import { sortBy } from 'lodash';

export const fetchSettings = async (): Promise<SettingsDto> => {
  try {
    const data = (await API.get<SettingsDto>(`/v2/settings/`)).data;

    data.organization_register_questions = sortBy(data.organization_register_questions, 'priority');
    data.header_links = sortBy(data.header_links, 'priority');

    return data;
  } catch (e) {
    throw new FormSubmitError('An error occurred while sending request to the server. Please try again.');
  }
};

const getQueryKey = () => ['settings/settings'];

const useSettings = () => useQuery(getQueryKey(), fetchSettings);

useSettings.getQueryKey = getQueryKey;
useSettings.queries = {
  fetchSettings,
} as const;

export default useSettings;
